import React from "react";

const userContext = React.createContext({
    webShare:null,
    setWs: () => {},
    teleport:null,
    p5:null
});
export default userContext;
